export default {"src":"/_next/static/media/vector.af6e2b84.svg","height":2,"width":237,"blurWidth":0,"blurHeight":0};